<template>
  <div class="shenbao">
    <div class="item_h">
      <div class="iteminfo">
        <div class="left_lable">采集状态:</div>
        <el-select v-model="cjcode" placeholder="请选择" size="small" clearable>
          <el-option label="数据采集中" value="1"></el-option>
          <el-option label="数据采集失败" value="2"></el-option>
          <el-option label="数据采集成功" value="3"></el-option>
        </el-select>
      </div>
      <div class="iteminfo">
        <div class="left_lable">评估状态:</div>
        <el-select v-model="pgcode" placeholder="请选择" size="small" clearable>
          <el-option label="未评估" value="0"></el-option>
          <el-option label="评估中" value="1"></el-option>
          <el-option label="评估失败" value="2"></el-option>
          <el-option label="评估成功" value="3"></el-option>
        </el-select>
      </div>
      <div class="iteminfo">
        <div class="left_lable">评估月份:</div>
        <el-date-picker
          clearable
          value-format="yyyy-MM"
          v-model="pgyf"
          type="month"
          placeholder="选择月"
        >
        </el-date-picker>
      </div>
    </div>

    <div class="shenbao_btn">
      <el-popover placement="right" trigger="click">
        <div>
          <div class="qrclass">
            <h3 class="wxgm">微信扫描二维码进行购买</h3>
            <div id="qrcode"></div>
          </div>
        </div>
        <el-button
          v-if="cxlx == 1"
          style="background: #53acf3; color: white"
          slot="reference"
          @click="toBuy"
          >购买</el-button
        >
      </el-popover>

      <el-button style="background: #53acf3; color: white" @click="init"
        >查询</el-button
      >
    </div>

    <div class="t_list">
      <el-table :data="sblist" border style="width: 100%" height="390">
        <el-table-column type="index" width="50" fixed> </el-table-column>
        <el-table-column label="采集状态" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.cjcode == 1">数据采集中</div>
            <div v-if="scope.row.cjcode == 2">数据采集失败</div>
            <div v-if="scope.row.cjcode == 3">数据采集成功</div>
          </template>
        </el-table-column>
        <el-table-column label="评估状态" width="80">
          <template slot-scope="scope">
            <div v-if="scope.row.pgcode == 0">未评估</div>
            <div v-if="scope.row.pgcode == 1">评估中</div>
            <div v-if="scope.row.pgcode == 2">评估失败</div>
            <div v-if="scope.row.pgcode == 3">评估成功</div>
          </template>
        </el-table-column>
        <el-table-column prop="pgyf" label="评估月份" width="80">
        </el-table-column>

        <el-table-column prop="bgqq" label="报告期起" width="100">
        </el-table-column>
        <el-table-column prop="bgqz" label="报告期止" width="100">
        </el-table-column>

        <el-table-column prop="shxydm" label="税号" width="200">
        </el-table-column>
        <el-table-column label="快速链接" fixed="right">
          <template slot-scope="scope">
            <div class="right_bb">
              <el-button
                type="text"
                size="small"
                @click="toPay(scope.row, 2)"
                v-if="
                  cxlx == 1 && (scope.row.pgcode == 2 || scope.row.cjcode == 2)
                "
              >
                重新评估
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="download(scope.row.file1)"
                v-if="scope.row.file1"
              >
                查看下载
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye">
        <el-pagination
          background
          layout="total, pager"
          :total="total"
          @current-change="pagechange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api/api'
import QRCode from 'qrcodejs2'
import store from 'store'
import { mapGetters } from 'vuex'
import { USR_TOKEN } from '@/util/const'
export default {
  name: 'recommend',
  props: {
    cxlx: '',
  },

  data() {
    return {
      haveQr: false,
      nsrsbh: '',
      ph: '',
      kkcode: '',
      sbcode: '',
      pgyf: '',
      referral: {},
      showNonePage: true,
      sblist: [],
      currentPage: '1',
      total: 0,
      cjcode: '',
      pgcode: '',
    }
  },
  computed: {},

  created() {
    // this.init()
    // return
    if (!this.userInfo.taxpayerNumber) {
      this.$alert('您还未绑定社会信用代码，请先完善信息', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        showClose: false,
      }).then(() => {
        this.$router.push({
          name: 'userInfo',
        })
      })
      return
    }
    if (!this.userInfo.taxControlPanelNumber) {
      this.$alert('您还未绑定税控盘号，请先完善信息', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        showClose: false,
      }).then(() => {
        this.$router.push({
          name: 'userInfo',
        })
      })
      return
    }
    this.init()
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  mounted() {},
  methods: {
    toPay(val, index) {
      this.$router.push({
        name: 'robotLogin',
        query: {
          type: index,
          nsrsbh: val.shxydm,
          op: 'fxpg',
          ph: this.userInfo.taxControlPanelNumber,
        },
      })
    },

    async init() {
      this.sblist = []
      let request = {
        shxydm: this.userInfo.taxpayerNumber, // '915101075564099285',
        //shxydm: '915101073952526822', // '915101075564099285',
        pgyf: this.pgyf || '',
        cjcode: this.cjcode.toString() || '',
        pgcode: this.pgcode || '',
        currentPage: this.currentPage,
        pageSize: '10',
        isJson: true,
        cxlx: this.cxlx,
      }
      const res = await API.cxfxpgjl(request)
      if (res.data.statusCode == 200) {
        this.sblist = [...res.data.result.list]
        this.total = parseInt(res.data.result.total)
      }
    },
    pagechange(val) {
      this.currentPage = val
      this.init()
    },
    download(val, title) {
      //res.data是获取接口返回的文件流
      window.open(val)

      return
      let url = val
      const a = document.createElement('a')
      a.href = url
      a.download = 'title' // 下载后文件名
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click() // 点击下载
      document.body.removeChild(a) // 下载完成移除元素
    },

    toBuy() {
      if (this.haveQr == true) {
        return
      }
      let token = store.get(USR_TOKEN)
      let nsrsbh = this.userInfo.taxpayerNumber
      let skph = this.userInfo.taxControlPanelNumber
      let id = this.userInfo.id
      //http://192.168.3.19:8080
      //https://www.chinaqjwx.cn/qf_moblie/#/ckzs
      let op = 'fxpg'
      this.haveQr = true
      //let text = 'https://www.chinaqjwx.cn/qf_moblie/#/ckzs?op='
      let text =
        'https://www.chinaqjwx.cn/qf_moblie/#/ckzs?op=' +
        op +
        '&nsrsbh=' +
        nsrsbh +
        '&skph=' +
        skph +
        '&id=' +
        id +
        '&token=' +
        token
      let qrcode = new QRCode('qrcode', {
        width: 300, // 设置宽度，单位像素
        height: 300, // 设置高度，单位像素
        text: text, // 设置二维码内容或跳转地址
      })
      console.log(text)
    },
  },
  components: {},
}
</script>

<style lang="stylus" scoped>
.fenye {
  margin-top: 10px;
}

.right_bb {
  display: flex;
}

/deep/ .el-tabs__nav-scroll {
  background-color: #ffffff;
}

.shenbao {
  width: 94%;
  margin: auto;
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  border-radius: 8px;
}

.none-pager {
  text-align: center;
  padding-top: 60px;
}

.uc-my-recmd {
  height: 500px;
  box-sizing: border-box;
  background-color: #F2F4F8;
  overflow: hidden;
}

.iteminfo {
  display: flex;
  align-items: center;
}

.item_h {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.left_lable {
  width: 80px;
  text-align: right;
  margin-right: 10px;
}

.shenbao_btn {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.tixing {
  color: red;
  margin-top: 10px;
  margin-bottom: 10px;
}

/deep/ .el-tabs__content {
  height: 530px;
  overflow: auto;
}

.t_list {
  margin-top: 20px;

}
.wxgm{
  text-align: center;
}
</style>
